import styled from 'styled-components'
import Icon from '@mdi/react'
import theme from 'theme_'
import { CommonLinkButton } from 'components/Button'

export const DeleteIcon = styled(Icon)<{ disabled?: boolean }>`
  color: ${(p) =>
    p.disabled ? theme.colors.disabledGrey : theme.colors.horizonOrange};

  :hover {
    opacity: ${(p) => (p.disabled ? 1 : 0.8)};
  }
`

export const DeleteLinkButton = styled(CommonLinkButton)`
  padding: 0 6px;
  min-height: ${theme.spacing.md};
`

export const DeleteIconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  min-height: ${theme.spacing.md};
`
